import React from "react";
import { Link } from "react-router-dom";
import "./HomeDashboardFooter.css";

const HomeDashboardFooter = () => {
  return (
    <footer className="dashboard-footer">
      <div className="dashboard-footer__container">
        <p className="dashboard-footer__copyright">
          © 2026 Vidyakasam Education. All Rights Reserved.
        </p>

        <nav
          className="dashboard-footer__links"
          aria-label="Footer navigation"
        >
          <Link to="/support">Support</Link>

          <Link to="/privacy-policy">Privacy Policy</Link>

          <Link to="/terms-and-conditions">
            Terms & Conditions
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default HomeDashboardFooter;